import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";

import Particle from "../Particle";
import pdf from "../../Assets/Sumanth_Nandeti_Resume.pdf";

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import GoogleDocsToPdf from "./GoogleDocToPdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />

        <Row className="resume">
          <GoogleDocsToPdf />
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
